import type { LangMap } from "./index";

export const notes: LangMap = {
  it: {
    formula: {
      trigger: "Formula",
      title: "Editor di formule",
      description: "Scrivi la formula in LaTeX: la vedi subito renderizzata e la inserisco nel testo senza rovinarlo.",
      preview: "Anteprima",
      emptyPreview: "Scrivi o scegli un simbolo.",
      inline: "Formula nel testo",
      block: "Formula su riga separata",
      insert: "Inserisci",
    },
    studio: {
      savingStatus: "Salvo…",
      savedStatus: "Salvato",
      title: "Crea i tuoi appunti con l'IA",
      subtitle: "Carica testo, audio o una foto: il tutor scrive appunti chiari con titoli, colori e domande-guida.",
      source: "Fonte",
      tabText: "Testo",
      tabAudio: "Audio",
      tabImage: "Foto",
      textPlaceholder: "Incolla qui appunti, un capitolo, una spiegazione…",
      uploadTextFile: "Carica .txt / .md",
      transcribing: "Trascrivo…",
      uploadAudioFile: "Carica file audio",
      maxAudioSize: "max 20MB",
      stop: "Ferma",
      recordNow: "Registra ora",
      from: "Da",
      readingImage: "Leggo l'immagine…",
      uploadPhoto: "Carica una foto",
      photoHint: "Appunti, pagina di libro, lavagna · max 10MB",
      titleLabel: "Titolo",
      titlePlaceholder: "Es. La rivoluzione francese",
      format: "Formato",
      formatComplete: "Completo (consigliato)",
      formatQA: "Domande & risposte",
      formatOutline: "Schema per ripasso",
      formatSynthetic: "Sintetico",
      instructions: "Istruzioni per il tutor",
      optional: "(opzionale)",
      instructionsPlaceholder: "Es. Concentrati sulle cause, aggiungi esempi pratici, spiegalo come se avessi 14 anni…",
      generating: "Sto scrivendo i tuoi appunti…",
      generate: "Genera appunti",
      libraryTitle: "I miei riassunti",
      libraryItemLabel: "riassunto",
      toastReady: "Appunti pronti ✨",
      toastFileTooBig: "File troppo grande (max 2MB)",
      toastTextLoaded: "Testo caricato",
      toastAudioTooBig: "Audio troppo grande (max 20MB)",
      toastAudioTranscribed: "Audio trascritto ✨",
      toastImageTooBig: "Immagine troppo grande (max 10MB)",
      toastTextExtracted: "Testo estratto ✨",
      toastMicUnavailable: "Microfono non disponibile",
      defaultTitle: "Appunti",
      recordingFilename: "registrazione",
    },
    view: {
      badge: "Appunti",
      sectionLabel: "Sezione {{n}}",
      example: "Esempio:",
      glossary: "Glossario",
      summary: "In sintesi",
    },
    plan: {
      paywallTitle: "Piano di studio personalizzato",
      paywallDesc: "Un piano giornaliero calibrato sui tuoi metodi, con blocchi Pomodoro, obiettivi SMART e promemoria.",
      paywallDuration: "40 min",
      paywallMethod: "Feynman",
      paywallSample: "Ripasso Storia — capitolo 4",
      paywallGoal: "Obiettivo: rispiegare 3 concetti chiave a voce alta.",
      paywallBreakDuration: "10 min",
      paywallBreak: "Pausa",
      newBadge: "Nuovo",
      generateTitle: "Genera il tuo piano di studio",
      generateDesc: "Un piano giornaliero personalizzato sui tuoi 3 metodi e sul tuo livello, con obiettivi e promemoria.",
      generatedOn: "generato il {{date}}",
      todayGoals: "Obiettivi di oggi",
      goal: "Obiettivo:",
      reminders: "Promemoria",
      regenerate: "Rigenera",
      remove: "Rimuovi",
      dialogTitle: "Genera il tuo piano di studio",
      dialogDesc: "Basato sui tuoi metodi consigliati ({{methods}}) e sul tuo livello {{level}}.",
      minutesPerDay: "Minuti al giorno",
      startTime: "Orario di inizio",
      subjects: "Materie (opzionale, separate da virgola)",
      subjectsPlaceholder: "es. Matematica, Storia, Inglese",
      tutorNotes: "Note per il tutor (opzionale)",
      tutorNotesPlaceholder: "Es. domani ho verifica di storia, oggi voglio ripassare i capitoli 4-5",
      creating: "Sto creando il piano…",
      generateCta: "Genera piano",
      toastReady: "Piano di studio pronto ✨",
      toastRemoved: "Piano rimosso",
      toastError: "Impossibile generare il piano",
    },
    media: {
      readError: "Impossibile leggere il file",
      audioTooBig: "Audio troppo grande (max 20MB)",
      audioTranscribed: "Audio trascritto ✨",
      imageTooBig: "Immagine troppo grande (max 10MB)",
      imageExtracted: "Testo estratto dalla foto ✨",
      aiAttachments: "Allegati IA",
      transcriptionFeature: "Trascrizione audio",
      extractionFeature: "Estrazione testo da foto",
      audio: "Audio",
      photo: "Foto",
    },
  },
  en: {
    formula: {
      trigger: "Formula",
      title: "Formula editor",
      description: "Write the formula in LaTeX: you see it rendered instantly and I insert it into the text without breaking it.",
      preview: "Preview",
      emptyPreview: "Type or pick a symbol.",
      inline: "Inline formula",
      block: "Formula on its own line",
      insert: "Insert",
    },
    studio: {
      savingStatus: "Saving…",
      savedStatus: "Saved",
      title: "Create your notes with AI",
      subtitle: "Upload text, audio or a photo: the tutor writes clear notes with titles, colors and guiding questions.",
      source: "Source",
      tabText: "Text",
      tabAudio: "Audio",
      tabImage: "Photo",
      textPlaceholder: "Paste notes, a chapter, an explanation here…",
      uploadTextFile: "Upload .txt / .md",
      transcribing: "Transcribing…",
      uploadAudioFile: "Upload audio file",
      maxAudioSize: "max 20MB",
      stop: "Stop",
      recordNow: "Record now",
      from: "From",
      readingImage: "Reading the image…",
      uploadPhoto: "Upload a photo",
      photoHint: "Notes, book page, whiteboard · max 10MB",
      titleLabel: "Title",
      titlePlaceholder: "E.g. The French Revolution",
      format: "Format",
      formatComplete: "Complete (recommended)",
      formatQA: "Questions & answers",
      formatOutline: "Review outline",
      formatSynthetic: "Concise",
      instructions: "Instructions for the tutor",
      optional: "(optional)",
      instructionsPlaceholder: "E.g. Focus on the causes, add practical examples, explain it as if I were 14…",
      generating: "Writing your notes…",
      generate: "Generate notes",
      libraryTitle: "My summaries",
      libraryItemLabel: "summary",
      toastReady: "Notes ready ✨",
      toastFileTooBig: "File too large (max 2MB)",
      toastTextLoaded: "Text loaded",
      toastAudioTooBig: "Audio too large (max 20MB)",
      toastAudioTranscribed: "Audio transcribed ✨",
      toastImageTooBig: "Image too large (max 10MB)",
      toastTextExtracted: "Text extracted ✨",
      toastMicUnavailable: "Microphone not available",
      defaultTitle: "Notes",
      recordingFilename: "recording",
    },
    view: {
      badge: "Notes",
      sectionLabel: "Section {{n}}",
      example: "Example:",
      glossary: "Glossary",
      summary: "Summary",
    },
    plan: {
      paywallTitle: "Personalized study plan",
      paywallDesc: "A daily plan calibrated to your methods, with Pomodoro blocks, SMART goals and reminders.",
      paywallDuration: "40 min",
      paywallMethod: "Feynman",
      paywallSample: "History review — chapter 4",
      paywallGoal: "Goal: re-explain 3 key concepts out loud.",
      paywallBreakDuration: "10 min",
      paywallBreak: "Break",
      newBadge: "New",
      generateTitle: "Generate your study plan",
      generateDesc: "A daily plan personalized on your 3 methods and your level, with goals and reminders.",
      generatedOn: "generated on {{date}}",
      todayGoals: "Today's goals",
      goal: "Goal:",
      reminders: "Reminders",
      regenerate: "Regenerate",
      remove: "Remove",
      dialogTitle: "Generate your study plan",
      dialogDesc: "Based on your recommended methods ({{methods}}) and your level {{level}}.",
      minutesPerDay: "Minutes per day",
      startTime: "Start time",
      subjects: "Subjects (optional, comma-separated)",
      subjectsPlaceholder: "e.g. Math, History, English",
      tutorNotes: "Notes for the tutor (optional)",
      tutorNotesPlaceholder: "E.g. I have a history test tomorrow, today I want to review chapters 4-5",
      creating: "Creating your plan…",
      generateCta: "Generate plan",
      toastReady: "Study plan ready ✨",
      toastRemoved: "Plan removed",
      toastError: "Unable to generate the plan",
    },
    media: {
      readError: "Unable to read the file",
      audioTooBig: "Audio too large (max 20MB)",
      audioTranscribed: "Audio transcribed ✨",
      imageTooBig: "Image too large (max 10MB)",
      imageExtracted: "Text extracted from the photo ✨",
      aiAttachments: "AI attachments",
      transcriptionFeature: "Audio transcription",
      extractionFeature: "Text extraction from photo",
      audio: "Audio",
      photo: "Photo",
    },
  },
  es: {
    formula: {
      trigger: "Fórmula",
      title: "Editor de fórmulas",
      description: "Escribe la fórmula en LaTeX: la ves al instante y la inserto en el texto sin romperlo.",
      preview: "Vista previa",
      emptyPreview: "Escribe o elige un símbolo.",
      inline: "Fórmula en el texto",
      block: "Fórmula en línea aparte",
      insert: "Insertar",
    },
    studio: {
      savingStatus: "Guardando…",
      savedStatus: "Guardado",
      title: "Crea tus apuntes con IA",
      subtitle: "Sube texto, audio o una foto: el tutor escribe apuntes claros con títulos, colores y preguntas guía.",
      source: "Fuente",
      tabText: "Texto",
      tabAudio: "Audio",
      tabImage: "Foto",
      textPlaceholder: "Pega aquí apuntes, un capítulo, una explicación…",
      uploadTextFile: "Subir .txt / .md",
      transcribing: "Transcribiendo…",
      uploadAudioFile: "Subir archivo de audio",
      maxAudioSize: "máx. 20MB",
      stop: "Detener",
      recordNow: "Grabar ahora",
      from: "De",
      readingImage: "Leyendo la imagen…",
      uploadPhoto: "Subir una foto",
      photoHint: "Apuntes, página de libro, pizarra · máx. 10MB",
      titleLabel: "Título",
      titlePlaceholder: "Ej. La Revolución Francesa",
      format: "Formato",
      formatComplete: "Completo (recomendado)",
      formatQA: "Preguntas y respuestas",
      formatOutline: "Esquema de repaso",
      formatSynthetic: "Sintético",
      instructions: "Instrucciones para el tutor",
      optional: "(opcional)",
      instructionsPlaceholder: "Ej. Concéntrate en las causas, añade ejemplos prácticos, explícalo como si tuviera 14 años…",
      generating: "Escribiendo tus apuntes…",
      generate: "Generar apuntes",
      libraryTitle: "Mis resúmenes",
      libraryItemLabel: "resumen",
      toastReady: "Apuntes listos ✨",
      toastFileTooBig: "Archivo demasiado grande (máx. 2MB)",
      toastTextLoaded: "Texto cargado",
      toastAudioTooBig: "Audio demasiado grande (máx. 20MB)",
      toastAudioTranscribed: "Audio transcrito ✨",
      toastImageTooBig: "Imagen demasiado grande (máx. 10MB)",
      toastTextExtracted: "Texto extraído ✨",
      toastMicUnavailable: "Micrófono no disponible",
      defaultTitle: "Apuntes",
      recordingFilename: "grabación",
    },
    view: {
      badge: "Apuntes",
      sectionLabel: "Sección {{n}}",
      example: "Ejemplo:",
      glossary: "Glosario",
      summary: "En resumen",
    },
    plan: {
      paywallTitle: "Plan de estudio personalizado",
      paywallDesc: "Un plan diario calibrado según tus métodos, con bloques Pomodoro, objetivos SMART y recordatorios.",
      paywallDuration: "40 min",
      paywallMethod: "Feynman",
      paywallSample: "Repaso de Historia — capítulo 4",
      paywallGoal: "Objetivo: reexplicar 3 conceptos clave en voz alta.",
      paywallBreakDuration: "10 min",
      paywallBreak: "Descanso",
      newBadge: "Nuevo",
      generateTitle: "Genera tu plan de estudio",
      generateDesc: "Un plan diario personalizado según tus 3 métodos y tu nivel, con objetivos y recordatorios.",
      generatedOn: "generado el {{date}}",
      todayGoals: "Objetivos de hoy",
      goal: "Objetivo:",
      reminders: "Recordatorios",
      regenerate: "Regenerar",
      remove: "Eliminar",
      dialogTitle: "Genera tu plan de estudio",
      dialogDesc: "Basado en tus métodos recomendados ({{methods}}) y tu nivel {{level}}.",
      minutesPerDay: "Minutos por día",
      startTime: "Hora de inicio",
      subjects: "Materias (opcional, separadas por comas)",
      subjectsPlaceholder: "ej. Matemáticas, Historia, Inglés",
      tutorNotes: "Notas para el tutor (opcional)",
      tutorNotesPlaceholder: "Ej. mañana tengo examen de historia, hoy quiero repasar los capítulos 4-5",
      creating: "Creando el plan…",
      generateCta: "Generar plan",
      toastReady: "Plan de estudio listo ✨",
      toastRemoved: "Plan eliminado",
      toastError: "No se pudo generar el plan",
    },
    media: {
      readError: "No se pudo leer el archivo",
      audioTooBig: "Audio demasiado grande (máx. 20MB)",
      audioTranscribed: "Audio transcrito ✨",
      imageTooBig: "Imagen demasiado grande (máx. 10MB)",
      imageExtracted: "Texto extraído de la foto ✨",
      aiAttachments: "Adjuntos IA",
      transcriptionFeature: "Transcripción de audio",
      extractionFeature: "Extracción de texto de foto",
      audio: "Audio",
      photo: "Foto",
    },
  },
  fr: {
    formula: {
      trigger: "Formule",
      title: "Éditeur de formules",
      description: "Écris la formule en LaTeX : tu la vois aussitôt rendue et je l'insère dans le texte sans le casser.",
      preview: "Aperçu",
      emptyPreview: "Écris ou choisis un symbole.",
      inline: "Formule dans le texte",
      block: "Formule sur sa propre ligne",
      insert: "Insérer",
    },
    studio: {
      savingStatus: "Enregistrement…",
      savedStatus: "Enregistré",
      title: "Crée tes notes avec l'IA",
      subtitle: "Télécharge du texte, de l'audio ou une photo : le tuteur rédige des notes claires avec titres, couleurs et questions guides.",
      source: "Source",
      tabText: "Texte",
      tabAudio: "Audio",
      tabImage: "Photo",
      textPlaceholder: "Colle ici des notes, un chapitre, une explication…",
      uploadTextFile: "Charger .txt / .md",
      transcribing: "Transcription…",
      uploadAudioFile: "Charger un fichier audio",
      maxAudioSize: "max 20 Mo",
      stop: "Arrêter",
      recordNow: "Enregistrer maintenant",
      from: "De",
      readingImage: "Lecture de l'image…",
      uploadPhoto: "Charger une photo",
      photoHint: "Notes, page de livre, tableau · max 10 Mo",
      titleLabel: "Titre",
      titlePlaceholder: "Ex. La Révolution française",
      format: "Format",
      formatComplete: "Complet (recommandé)",
      formatQA: "Questions & réponses",
      formatOutline: "Plan de révision",
      formatSynthetic: "Synthétique",
      instructions: "Instructions pour le tuteur",
      optional: "(facultatif)",
      instructionsPlaceholder: "Ex. Concentre-toi sur les causes, ajoute des exemples pratiques, explique comme si j'avais 14 ans…",
      generating: "Rédaction de tes notes…",
      generate: "Générer les notes",
      libraryTitle: "Mes résumés",
      libraryItemLabel: "résumé",
      toastReady: "Notes prêtes ✨",
      toastFileTooBig: "Fichier trop volumineux (max 2 Mo)",
      toastTextLoaded: "Texte chargé",
      toastAudioTooBig: "Audio trop volumineux (max 20 Mo)",
      toastAudioTranscribed: "Audio transcrit ✨",
      toastImageTooBig: "Image trop volumineuse (max 10 Mo)",
      toastTextExtracted: "Texte extrait ✨",
      toastMicUnavailable: "Microphone non disponible",
      defaultTitle: "Notes",
      recordingFilename: "enregistrement",
    },
    view: {
      badge: "Notes",
      sectionLabel: "Section {{n}}",
      example: "Exemple :",
      glossary: "Glossaire",
      summary: "En résumé",
    },
    plan: {
      paywallTitle: "Plan d'étude personnalisé",
      paywallDesc: "Un plan quotidien calibré sur tes méthodes, avec des blocs Pomodoro, des objectifs SMART et des rappels.",
      paywallDuration: "40 min",
      paywallMethod: "Feynman",
      paywallSample: "Révision d'Histoire — chapitre 4",
      paywallGoal: "Objectif : réexpliquer 3 concepts clés à voix haute.",
      paywallBreakDuration: "10 min",
      paywallBreak: "Pause",
      newBadge: "Nouveau",
      generateTitle: "Génère ton plan d'étude",
      generateDesc: "Un plan quotidien personnalisé selon tes 3 méthodes et ton niveau, avec objectifs et rappels.",
      generatedOn: "généré le {{date}}",
      todayGoals: "Objectifs du jour",
      goal: "Objectif :",
      reminders: "Rappels",
      regenerate: "Régénérer",
      remove: "Supprimer",
      dialogTitle: "Génère ton plan d'étude",
      dialogDesc: "Basé sur tes méthodes recommandées ({{methods}}) et ton niveau {{level}}.",
      minutesPerDay: "Minutes par jour",
      startTime: "Heure de début",
      subjects: "Matières (facultatif, séparées par des virgules)",
      subjectsPlaceholder: "ex. Mathématiques, Histoire, Anglais",
      tutorNotes: "Notes pour le tuteur (facultatif)",
      tutorNotesPlaceholder: "Ex. j'ai un contrôle d'histoire demain, aujourd'hui je veux réviser les chapitres 4-5",
      creating: "Création du plan…",
      generateCta: "Générer le plan",
      toastReady: "Plan d'étude prêt ✨",
      toastRemoved: "Plan supprimé",
      toastError: "Impossible de générer le plan",
    },
    media: {
      readError: "Impossible de lire le fichier",
      audioTooBig: "Audio trop volumineux (max 20 Mo)",
      audioTranscribed: "Audio transcrit ✨",
      imageTooBig: "Image trop volumineuse (max 10 Mo)",
      imageExtracted: "Texte extrait de la photo ✨",
      aiAttachments: "Pièces jointes IA",
      transcriptionFeature: "Transcription audio",
      extractionFeature: "Extraction de texte depuis une photo",
      audio: "Audio",
      photo: "Photo",
    },
  },
  de: {
    formula: {
      trigger: "Formel",
      title: "Formel-Editor",
      description: "Schreibe die Formel in LaTeX: Du siehst sie sofort gerendert und ich füge sie ein, ohne den Text zu zerstören.",
      preview: "Vorschau",
      emptyPreview: "Schreibe oder wähle ein Symbol.",
      inline: "Formel im Text",
      block: "Formel in eigener Zeile",
      insert: "Einfügen",
    },
    studio: {
      savingStatus: "Speichern…",
      savedStatus: "Gespeichert",
      title: "Erstelle deine Notizen mit KI",
      subtitle: "Lade Text, Audio oder ein Foto hoch: Der Tutor schreibt klare Notizen mit Titeln, Farben und Leitfragen.",
      source: "Quelle",
      tabText: "Text",
      tabAudio: "Audio",
      tabImage: "Foto",
      textPlaceholder: "Füge hier Notizen, ein Kapitel oder eine Erklärung ein…",
      uploadTextFile: ".txt / .md hochladen",
      transcribing: "Transkribiere…",
      uploadAudioFile: "Audiodatei hochladen",
      maxAudioSize: "max. 20MB",
      stop: "Stopp",
      recordNow: "Jetzt aufnehmen",
      from: "Von",
      readingImage: "Bild wird gelesen…",
      uploadPhoto: "Foto hochladen",
      photoHint: "Notizen, Buchseite, Tafel · max. 10MB",
      titleLabel: "Titel",
      titlePlaceholder: "Z. B. Die Französische Revolution",
      format: "Format",
      formatComplete: "Vollständig (empfohlen)",
      formatQA: "Fragen & Antworten",
      formatOutline: "Übersicht zum Wiederholen",
      formatSynthetic: "Kurz",
      instructions: "Anweisungen für den Tutor",
      optional: "(optional)",
      instructionsPlaceholder: "Z. B. Konzentriere dich auf die Ursachen, füge praktische Beispiele hinzu, erkläre es, als wäre ich 14…",
      generating: "Deine Notizen werden geschrieben…",
      generate: "Notizen erstellen",
      libraryTitle: "Meine Zusammenfassungen",
      libraryItemLabel: "Zusammenfassung",
      toastReady: "Notizen fertig ✨",
      toastFileTooBig: "Datei zu groß (max. 2MB)",
      toastTextLoaded: "Text geladen",
      toastAudioTooBig: "Audio zu groß (max. 20MB)",
      toastAudioTranscribed: "Audio transkribiert ✨",
      toastImageTooBig: "Bild zu groß (max. 10MB)",
      toastTextExtracted: "Text extrahiert ✨",
      toastMicUnavailable: "Mikrofon nicht verfügbar",
      defaultTitle: "Notizen",
      recordingFilename: "Aufnahme",
    },
    view: {
      badge: "Notizen",
      sectionLabel: "Abschnitt {{n}}",
      example: "Beispiel:",
      glossary: "Glossar",
      summary: "Zusammenfassung",
    },
    plan: {
      paywallTitle: "Personalisierter Lernplan",
      paywallDesc: "Ein Tagesplan, abgestimmt auf deine Methoden, mit Pomodoro-Blöcken, SMART-Zielen und Erinnerungen.",
      paywallDuration: "40 Min",
      paywallMethod: "Feynman",
      paywallSample: "Geschichte wiederholen — Kapitel 4",
      paywallGoal: "Ziel: 3 Schlüsselkonzepte laut erklären.",
      paywallBreakDuration: "10 Min",
      paywallBreak: "Pause",
      newBadge: "Neu",
      generateTitle: "Erstelle deinen Lernplan",
      generateDesc: "Ein Tagesplan, personalisiert auf deine 3 Methoden und dein Niveau, mit Zielen und Erinnerungen.",
      generatedOn: "erstellt am {{date}}",
      todayGoals: "Heutige Ziele",
      goal: "Ziel:",
      reminders: "Erinnerungen",
      regenerate: "Neu erstellen",
      remove: "Entfernen",
      dialogTitle: "Erstelle deinen Lernplan",
      dialogDesc: "Basierend auf deinen empfohlenen Methoden ({{methods}}) und deinem Niveau {{level}}.",
      minutesPerDay: "Minuten pro Tag",
      startTime: "Startzeit",
      subjects: "Fächer (optional, durch Kommas getrennt)",
      subjectsPlaceholder: "z. B. Mathematik, Geschichte, Englisch",
      tutorNotes: "Hinweise für den Tutor (optional)",
      tutorNotesPlaceholder: "Z. B. morgen habe ich einen Geschichtstest, heute möchte ich die Kapitel 4-5 wiederholen",
      creating: "Plan wird erstellt…",
      generateCta: "Plan erstellen",
      toastReady: "Lernplan fertig ✨",
      toastRemoved: "Plan entfernt",
      toastError: "Der Plan konnte nicht erstellt werden",
    },
    media: {
      readError: "Datei konnte nicht gelesen werden",
      audioTooBig: "Audio zu groß (max. 20MB)",
      audioTranscribed: "Audio transkribiert ✨",
      imageTooBig: "Bild zu groß (max. 10MB)",
      imageExtracted: "Text aus dem Foto extrahiert ✨",
      aiAttachments: "KI-Anhänge",
      transcriptionFeature: "Audiotranskription",
      extractionFeature: "Textextraktion aus Foto",
      audio: "Audio",
      photo: "Foto",
    },
  },
  pt: {
    formula: {
      trigger: "Fórmula",
      title: "Editor de fórmulas",
      description: "Escreve a fórmula em LaTeX: vês logo o resultado e insiro-a no texto sem o estragar.",
      preview: "Pré-visualização",
      emptyPreview: "Escreve ou escolhe um símbolo.",
      inline: "Fórmula no texto",
      block: "Fórmula em linha própria",
      insert: "Inserir",
    },
    studio: {
      savingStatus: "Salvando…",
      savedStatus: "Salvo",
      title: "Crie suas anotações com IA",
      subtitle: "Envie texto, áudio ou uma foto: o tutor escreve anotações claras com títulos, cores e perguntas-guia.",
      source: "Fonte",
      tabText: "Texto",
      tabAudio: "Áudio",
      tabImage: "Foto",
      textPlaceholder: "Cole aqui anotações, um capítulo, uma explicação…",
      uploadTextFile: "Enviar .txt / .md",
      transcribing: "Transcrevendo…",
      uploadAudioFile: "Enviar arquivo de áudio",
      maxAudioSize: "máx. 20MB",
      stop: "Parar",
      recordNow: "Gravar agora",
      from: "De",
      readingImage: "Lendo a imagem…",
      uploadPhoto: "Enviar uma foto",
      photoHint: "Anotações, página de livro, quadro · máx. 10MB",
      titleLabel: "Título",
      titlePlaceholder: "Ex. A Revolução Francesa",
      format: "Formato",
      formatComplete: "Completo (recomendado)",
      formatQA: "Perguntas e respostas",
      formatOutline: "Esquema de revisão",
      formatSynthetic: "Sintético",
      instructions: "Instruções para o tutor",
      optional: "(opcional)",
      instructionsPlaceholder: "Ex. Concentre-se nas causas, adicione exemplos práticos, explique como se eu tivesse 14 anos…",
      generating: "Escrevendo suas anotações…",
      generate: "Gerar anotações",
      libraryTitle: "Meus resumos",
      libraryItemLabel: "resumo",
      toastReady: "Anotações prontas ✨",
      toastFileTooBig: "Arquivo muito grande (máx. 2MB)",
      toastTextLoaded: "Texto carregado",
      toastAudioTooBig: "Áudio muito grande (máx. 20MB)",
      toastAudioTranscribed: "Áudio transcrito ✨",
      toastImageTooBig: "Imagem muito grande (máx. 10MB)",
      toastTextExtracted: "Texto extraído ✨",
      toastMicUnavailable: "Microfone não disponível",
      defaultTitle: "Anotações",
      recordingFilename: "gravação",
    },
    view: {
      badge: "Anotações",
      sectionLabel: "Seção {{n}}",
      example: "Exemplo:",
      glossary: "Glossário",
      summary: "Em resumo",
    },
    plan: {
      paywallTitle: "Plano de estudos personalizado",
      paywallDesc: "Um plano diário calibrado com base nos seus métodos, com blocos Pomodoro, metas SMART e lembretes.",
      paywallDuration: "40 min",
      paywallMethod: "Feynman",
      paywallSample: "Revisão de História — capítulo 4",
      paywallGoal: "Meta: reexplicar 3 conceitos-chave em voz alta.",
      paywallBreakDuration: "10 min",
      paywallBreak: "Pausa",
      newBadge: "Novo",
      generateTitle: "Gere seu plano de estudos",
      generateDesc: "Um plano diário personalizado com base nos seus 3 métodos e no seu nível, com metas e lembretes.",
      generatedOn: "gerado em {{date}}",
      todayGoals: "Metas de hoje",
      goal: "Meta:",
      reminders: "Lembretes",
      regenerate: "Regenerar",
      remove: "Remover",
      dialogTitle: "Gere seu plano de estudos",
      dialogDesc: "Baseado nos seus métodos recomendados ({{methods}}) e no seu nível {{level}}.",
      minutesPerDay: "Minutos por dia",
      startTime: "Horário de início",
      subjects: "Matérias (opcional, separadas por vírgula)",
      subjectsPlaceholder: "ex. Matemática, História, Inglês",
      tutorNotes: "Notas para o tutor (opcional)",
      tutorNotesPlaceholder: "Ex. amanhã tenho prova de história, hoje quero revisar os capítulos 4-5",
      creating: "Criando o plano…",
      generateCta: "Gerar plano",
      toastReady: "Plano de estudos pronto ✨",
      toastRemoved: "Plano removido",
      toastError: "Não foi possível gerar o plano",
    },
    media: {
      readError: "Não foi possível ler o arquivo",
      audioTooBig: "Áudio muito grande (máx. 20MB)",
      audioTranscribed: "Áudio transcrito ✨",
      imageTooBig: "Imagem muito grande (máx. 10MB)",
      imageExtracted: "Texto extraído da foto ✨",
      aiAttachments: "Anexos de IA",
      transcriptionFeature: "Transcrição de áudio",
      extractionFeature: "Extração de texto de foto",
      audio: "Áudio",
      photo: "Foto",
    },
  },
};
